import PropTypes from 'prop-types';
import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'
import StaticContainer from 'react-static-container'

export default class extends React.Component {
    static propTypes = {
		pathname: PropTypes.string
	};

    state = {
        previousPathname: null
    };

    componentWillReceiveProps(nextProps, nextContext) {
		if ('location' in nextContext && nextContext.location.pathname !== this.props.location.pathname) {
			this.setState({ previousPathname: this.props.location.pathname })
		}
	}

    render() {
		const { children, session, location, ...props } = this.props
		const { previousPathname } = this.state

		return (
			<CSSTransitionGroup {...props}>
				<StaticContainer
					key={previousPathname || location.pathname}
					shouldUpdate={!previousPathname}
				>
					{children}
				</StaticContainer>
			</CSSTransitionGroup>
		)
	}

    componentDidUpdate() {
		if (this.state.previousPathname) {
			this.setState({ previousPathname: null })
		}
	}
}



// WEBPACK FOOTER //
// ./src/js/components/RouteCSSTransition.js